import React from 'react'
import './../Form.css'

const GridContainer = ({children, itemsPerRow}) => {
    let className = "grid-element";
    if(itemsPerRow){
        className +=" grid-element-"+itemsPerRow
    }
    return (
        <div className={className} >
            { children }
        </div>
    )
}

export default GridContainer
